import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProdutosPage = lazy(() => import('../pages/produtos/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const QuemSomosPage = lazy(() => import('../pages/quem-somos/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/produtos',
    element: <ProdutosPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/quem-somos',
    element: <QuemSomosPage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
